import { makeStyles } from '@material-ui/core';
import { Custom, ThemeInstance } from 'configs/theme';

export interface CSSProps {
  background: Custom;
}

export const useStyles = makeStyles<ThemeInstance, CSSProps>((theme) => ({
  root: (props) => ({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    borderLeft: `5px solid ${theme.custom[props.background]}`,
  }),
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    minHeight: 280,
    background: '#fff',
  },
  centered: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  border: (props) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    minHeight: 45,
    marginLeft: -1,
    padding: '10px 15px',
    background: theme.custom[props.background],
  }),
  title: {
    fontSize: 16,
    fontWeight: 400,
    color: '#fff',
  },
  iconBtn: {
    background: '#F0F3F7',
  },
  icon: {
    fontSize: '1.3rem',
    color: theme.custom.darkBlue,
  },
  pointer: {
    cursor: 'pointer',
  },
}));
